import { WIZARDTYPES } from 'src/app/settings/integrations/connectwise/core/constants/wizard-types.const'

export const WIZARDNAVS = [
    { name: 'Authenticate', value: WIZARDTYPES.authenticate, active: true, complete: false },
    { name: 'Map Products', value: WIZARDTYPES.mapproducts, active: false, complete: false },
    { name: 'Map Tickets', value: WIZARDTYPES.maptickets, active: false, complete: false },
    //{ name: 'Sync Settings', value: WIZARDTYPES.syncsettings, active: false, complete: false }
]